import React, {useState, useCallback, useEffect, useContext} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import { useLocation } from 'react-router-dom';
import AuthContext from '../../contexts/AuthContext';
import ToastContext from '../../contexts/ToastContext';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import { View, Text } from 'react-native';
// import { CREATE_FEE, CREATE_TITLE_LOG, SELECTS } from './queries';
import secrets from '../../../secrets';
import { rest } from '../../utils/rest';
import { Alert } from './Alert';

const TROUBLE_TICKET_TYPES = [
  'Something that used to work is not working',
  'Something isn’t working the way I expected',
  'Something new'
];

const NewTroubleTicket = ({setShowModal}) => {
  const auth = useContext(AuthContext);
  const toast = useContext(ToastContext);
  const [submitting, setSubmitting] = useState();
  const [alert, displayAlert] = useState({ message: null, variant: null });
  const location = useLocation();

  const onSubmit = useCallback(data => {
    setSubmitting(true);
    const formData = new FormData();
    formData.append('trouble_ticket', JSON.stringify({
      ...data,
      app_id: '30',
      app_name: 'el',
      client_id: '45885',
      status: 'New',
    }));
    let credentials = auth.credentials;
    // if (uploads) {
    //   uploads.forEach((upload, index) => {
    //     formData.append(`uploads[${index}]`, upload);
    //   });
    // }

    const options = {
      credentials,
      body: formData,
      url: secrets.pti.ticketUrl,
      method: 'post',
      skipDefaultHeaders: true,
      headers: {
        Authorization: secrets.pti.token,
        Accept: 'application/json',
      }
    };

    const timestamp = new Date().getTime();
    setShowModal(false);

    // axios.post(secrets.pti.ticketUrl, formData, config).then(res => {
    rest(options).then(res => res.json()).then(data => {
      let message;
      let variant;

      setSubmitting(false);
      if (data) {
        message = 'Thank you for contacting us. We will be in touch with you ' +
          'as quickly as possible. Your trouble ticket id is ' +
          `${data.app_name}${data.id}.`;
        variant = 'success';
      } else {
        message = 'There was an error handling your request.'
        variant = 'danger';
      }
      setShowModal(false);
      // displayAlert(Object.assign({}, {message, variant}));
      toast.notify(message, toast.standard)
    });
  });

  const { control, handleSubmit, getValues, setValue, register,
    formState: { errors }
  } = useForm({
    defaultValues: {
      type: '',
      name: `${auth?.user?.firstName} ${auth?.user?.lastName}` || '',
      phone: auth?.user?.mobilePhone || '',
      email: auth?.user?.email || '',
      url: window.location.href,
      subject: '',
      problem: '',
      expectation: '',
      supplied_url: window.location.href,
      user_id: auth?.user?.id,
    }
  });

  return (
    <View>
      {submitting ?
        <DataState.Loading /> :
        <View>

          <Input.Picker
            label="Type:"
            name="type"
            options={
              TROUBLE_TICKET_TYPES.map(type => { return { value: type, label: type }})
            }
            control={control}
            errors={errors}
            {...register("type", {
              required: "Required"
            })}
          />
          <Input.Text
            label="Your Name:"
            name="name"
            control={control}
            errors={errors}
          />
          <Input.Phone
            label="Phone Number:"
            name="phone"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Email:"
            name="email"
            control={control}
            errors={errors}
            id="email"
            {...register("email", {
              required: "Email is required",
              validate: {
                maxLength: (v) =>
                  v.length <= 50 || "The email should have at most 50 characters",
                matchPattern: (v) =>
                  /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                  "Email address must be a valid address",
              },
            })}
          />
          <Input.Text
            label="Where would we see your request? (Add a URL, Email Subject, or something else, if applicable)"
            name="url"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="In one sentence, what is your request? (This will be the title of the request)"
            name="subject"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="Please provide as many details about your request as possible:"
            name="problem"
            control={control}
            errors={errors}
          />
          <Input.Text
            label="If something wasn’t working correctly, what were you expecting to happen?"
            name="expectation"
            control={control}
            errors={errors}
          />
          {/* <CustomizableDropzone
            accept=".pdf, .xls, .xlsx, .doc, .docx, image/*"
            description="Upload attachment."
            files={values.uploads || []}
            setFiles={files => setFieldValue('uploads', files)}
            styles={{padding: 0, margin: 0}}
            descriptionStyle={{padding: 10, margin: 0}}
            className="form-dropzone"
          /> */}
          <ButtonContainer>
            <ButtonGroup>
              <Button label="Create Trouble Ticket" onPress={handleSubmit(onSubmit)} />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )
}

export default NewTroubleTicket;
